module.exports = __webpack_public_path__ + "fonts/icomoon.3dc5cf49c882953c0050060ff3d188ea.woff";